import { render, staticRenderFns } from "./RoundWard.vue?vue&type=template&id=a2dab010&"
import script from "./RoundWard.vue?vue&type=script&lang=js&"
export * from "./RoundWard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports